/**
 * FormField — wraps a label + control + optional hint/error.
 * Children receive aria-invalid via their own `error` prop; this
 * component only renders the surrounding layout.
 */
export function FormField({ label, htmlFor, error, hint, children }) {
  return (
    <div className="form-field">
      {label && (
        <label htmlFor={htmlFor} className="form-field-label">
          {label}
        </label>
      )}
      {children}
      {hint && !error && <div className="form-field-hint">{hint}</div>}
      {error && (
        <div className="form-field-error" role="alert">
          {error}
        </div>
      )}
    </div>
  );
}
